import { useState, useEffect } from "react";
import { OPERATOR_MANAGEMENT_SERVICE } from "src/utils/Api";
import { mockData } from "src/Pages/User/Operator/List";
import __ from "src/utils/Translations";
import useHasPermission from "src/utils/hooks/security/useHasPermission";
import { operatorOperatorPermissionRead } from "src/utils/RoleBasedSecurity/permissions";
import sendBatchRequests from "src/utils/Api/sendBatchRequests";
import { mappingOptions } from "src/utils/Api/modifyResponse";

// export default function useOperatorRoles(asOption = false, idAsIri = false) {
export default function useOperators(
  asOption = false,
  filterField = null,
  filterValue = null,
  idAsIri = false,
  noFetching = false
) {
  const [data, setData] = useState([]);
  const hasPermission = useHasPermission(operatorOperatorPermissionRead);
  const skipAction = !hasPermission || noFetching;
  useEffect(() => {
    const fetchData = async () =>
      sendBatchRequests({
        skipAction,
        filterField,
        filterValue,
        idAsIri,
        asOption,
        IRI_PREFIX,
        requestParams: {
          service: OPERATOR_MANAGEMENT_SERVICE,
          path: "/operators",
          method: "GET",
          mockData,
        },
        mappingType: mappingOptions.byFirstNameLastNameUsername,
        setData,
      });

    fetchData();
  }, [filterField, filterValue, idAsIri, asOption, skipAction]);

  return data;
}

export const IRI_PREFIX = "/api/operator-management/v1/rest/operators";
